<template>
  <div>
    <CartSection
      :title="$t('Customise your bundle with products designed to work together')"
    >
      <ComplementaryProductsInCart />
    </CartSection>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'ComplementaryProductsInner',

});

</script>
